import getters from './getters';
import actions from './actions';
import mutations from './mutations';

var state = () => ({
  total: null,
  products: null,
  description: null,
  productsPerPage: 40,
  tpl: 'liste produits'
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};